import actionTypes from '../constants/action-types';

const pageSettings = (state = {}, action) => {
  const { type, payload } = action;
  if (type === actionTypes.UPDATE_PAGE_SETTINGS && payload.pageId === state.id) {
    const { path } = payload.settings;
    const { path: currentPagePath } = state;

    if (path && path !== currentPagePath) {
      // provide trailing slash for path
      return {
        ...state,
        ...payload.settings,
        path: path.endsWith('/') ? path : `${path}/`,
      };
    }

    return {
      ...state,
      ...payload.settings,
    };
  }

  return state;
};

export default pageSettings;
